import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { connect } from 'react-redux'
import moment from 'moment'
import cloneDeep from 'lodash-es/cloneDeep'

import { getTokenType } from 'utils/tokenTypes'

import { Consumer as BNCClientConsumer } from '../../context/BNCClientProvider'
import { Consumer as WalletConnectClientConsumer } from '../../context/WalletConnectProvider'
import LedgerModalHost from '../../modals/LedgerModalHost'
import TrezorModalHost from '../../modals/TrezorModalHost'
import CoinomiModalHost from '../../modals/CoinomiModalHost'
import InfinitoModalHost from '../../modals/InfinitoModalHost'
import WalletConnectModal from '../../modals/WalletConnectModal'

import Header from '../../header'

import Layout from '../../../components/common/Layout'
import { Button } from '../../../components/common/Button'
import Icon from '../../../components/common/Icon'
import Confirm from '../../../components/common/Confirm'
import FontNumber from '../../../components/common/FontNumber'
import Notification from '../../../components/common/Notifycation'
import OrderTable from '../../../components/order/OrderTable'
import Filled from '../../../components/order/Filled'
import Side from '../../../components/order/Side'
import TxHash from '../../../components/order/TxHash'
import NoContent from '../../../components/common/NoContent'
import message from '../../../components/common/Message'
import Pagination from '../../../components/order/Pagination'
import { OpItem } from '../../../components/exchange/OpenOrders'
import OrderItemMobile from '../../../components/mobile/OrderItem'

import CancelWhite from '../../../static/images/cancelwhite.svg'
import Nodata from '../../../static/images/nodata.png'

import { getOpenOrdersQS } from '../../../redux/order/action'
import { setTriggerElement, setLoading } from '../../../redux/global/action'
import { setNeedAuth } from '../../../redux/account/action'
import { setWalletConnectURI } from '../../../redux/walletConnect/action'
import httpRequest from '../../../utils/httpRequest'
import { roundValue, toNonExponential } from '../../../utils/number'
import hasPrivateKey, { isUnlockWithWalletConnect } from '../../../utils/account'
import {
  MobileWrap,
  MobileContent,
  MobileTitle,
  GlobalStyle,
  MobileNoData,
} from '../../../components/mobile'
import { isMobile } from '../../../utils/bomUtils'
import { withI18n } from '../../../i18n/util'
import { DexThemeProvider } from '../../../components/common/DexThemeProvider'

const PAGE_SIZE = 30

const Wrapper = styled.div`
  background: #fdfdfd;
  display: flex;
  justify-content: center;
`

const Content = styled.div`
  width: 1200px;
  min-width: 960px;
`

const Title = styled.div`
  color: #212833;
  font-size: 20px;
  background: #fff;
  height: 40px;
  line-height: 30px;
`

const FilterWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  box-shadow: 0px 1px 20px 0px rgba(90, 102, 124, 0.08);
  height: 40px;
  padding: 0 5px 0 15px;
`

const FilterButtons = styled.div`
  display: flex;
`

export const FilterButton = styled(Button)`
  width: auto;
  background: #fff;
  color: #212833;
  padding: 0 10px;
  height: 24px;
  line-height: 23px;
  border: 1px solid #848e9c;
  box-sizing: border-box;
  font-size: 13px;
  margin-right: 10px;
  font-weight: 400;
  &:hover {
    border-color: #f0b90b;
    color: #f0b90b;
  }
`

const PageWrap = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
`

const CellItem = styled.div`
  color: #212833;
`

const DateItem = styled.div`
  color: #848e9c;
`

const ConfirmContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 100px;
    margin-bottom: 20px;
  }
`

const DesktopWrap = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`

const CancalAllMobile = styled.div`
  font-size: 14px;
  color: #f0b90b;
`

class OpenOrders extends PureComponent {
  static propTypes = {
    openOrders: PropTypes.array,
    total: PropTypes.number,
    dispatch: PropTypes.func,
    address: PropTypes.string,
    privateKey: PropTypes.string,
    userInfo: PropTypes.string,
    formatI18nText: PropTypes.func,
  }

  static defaultProps = {
    openOrders: [],
    total: 0,
    dispatch: () => {},
    address: '',
    privateKey: '',
    userInfo: {},
    formatI18nText: () => {},
  }

  constructor(props) {
    super(props)
    this.state = {
      isConfirm: false,
      toCancelItem: {},
    }
  }

  componentDidMount() {
    this._getOpenOrders()
  }

  _getOpenOrders = opts => {
    const tokenType = getTokenType()
    const { dispatch } = this.props
    let user = sessionStorage.getItem('user')
    user = (user && JSON.parse(user)) || {}
    if (!user.address) return
    const params = {
      address: user.address,
      offset: 0,
      total: 1,
      limit: PAGE_SIZE,
      ...opts,
    }
    dispatch(getOpenOrdersQS({ params, tokenType }))
  }

  _cancel = async (client, items = []) => {
    const { address, privateKey, dispatch, formatI18nText } = this.props

    privateKey !== 'HARDWARE' && (await client.setPrivateKey(privateKey))

    const account = (await httpRequest.getAccount(address)) || {}

    try {
      let msg = formatI18nText('openOrders.cancelSuccess')
      dispatch(setLoading(true))
      for (let i = 0, len = items.length; i < len; i++) {
        const res = await client.cancelOrder(
          address,
          items[i].symbol || items[i].pair,
          items[i].orderId,
          account.sequence + i
        )
        if (res) {
          /* eslint-disable-next-line */
          continue
        } else {
          msg = formatI18nText('openOrders.cancelPartialSuccess')
          break
        }
      }

      this.setState(
        {
          notifyType: 'success',
          notifyMsg: msg,
          notifyTitle: formatI18nText('openOrders.cancelSuccess'),
          showNotify: true,
          isConfirm: false,
        },
        () => {
          setTimeout(() => {
            this._getOpenOrders()
          }, 1500)
        }
      )
    } catch (err) {
      console.log(err)
      this.setState({
        notifyType: 'fail',
        notifyMsg: err.message || err || formatI18nText('openOrders.networkError'),
        notifyTitle: err.message || err || formatI18nText('openOrders.networkError'),
        showNotify: true,
        isConfirm: false,
      })
    }

    dispatch(setLoading(false))
  }

  _walletConnectCheck = async (wcClient, currentTarget) => {
    const { dispatch } = this.props
    if (isUnlockWithWalletConnect() && wcClient && !wcClient.connected()) {
      const uri = await wcClient.startSession(false)
      console.log('WalletConnect URI', uri)
      dispatch(setWalletConnectURI(uri))
      dispatch(setTriggerElement(currentTarget))
      return true
    }
    return false
  }

  _cancelAll = wcClient => async ev => {
    const { currentTarget } = ev
    const { openOrders, privateKey, dispatch, formatI18nText } = this.props
    if (openOrders.length === 0) {
      message.warn(formatI18nText('openOrders.noOpenOrders'))
      return
    }

    if (await this._walletConnectCheck(wcClient, currentTarget)) return

    if (!privateKey) {
      dispatch(setTriggerElement(currentTarget))
      dispatch(setNeedAuth(true))
      return
    }

    this.setState({ isConfirm: true, cancelText: 'cancel all' })
  }

  _cancelBuy = wcClient => async ev => {
    const { currentTarget } = ev
    const { openOrders, privateKey, dispatch, formatI18nText } = this.props
    const openBuyOrders = openOrders.find(item => item.side === 1)
    if (!openBuyOrders || openBuyOrders.length === 0) {
      message.warn(formatI18nText('openOrders.noBuyOpenOrders'))
      return
    }

    if (await this._walletConnectCheck(wcClient, currentTarget)) return

    if (!privateKey) {
      dispatch(setTriggerElement(currentTarget))
      dispatch(setNeedAuth(true))
      return
    }

    this.setState({ isConfirm: true, cancelText: 'cancel buy' })
  }

  _cancelSell = wcClient => async ev => {
    const { currentTarget } = ev
    const { openOrders, privateKey, dispatch, formatI18nText } = this.props
    const openSellOrders = openOrders.find(item => item.side === 2)
    if (!openSellOrders || openSellOrders.length === 0) {
      message.warn(formatI18nText('openOrders.noSellOpenOrders'))
      return
    }

    if (await this._walletConnectCheck(wcClient, currentTarget)) return

    if (!privateKey) {
      dispatch(setTriggerElement(currentTarget))
      dispatch(setNeedAuth(true))
      return
    }

    this.setState({ isConfirm: true, cancelText: 'cancel sell' })
  }

  _cancelOne = async (item, ev, wcClient) => {
    const { currentTarget } = ev
    const { privateKey, dispatch } = this.props

    if (await this._walletConnectCheck(wcClient, currentTarget)) return

    if (!privateKey) {
      dispatch(setTriggerElement(currentTarget))
      dispatch(setNeedAuth(true))
      return
    }

    this.setState({ isConfirm: true, cancelText: 'cancel', toCancelItem: item })
  }

  _confirmCancel = bncClient => () => {
    const { cancelText, toCancelItem } = this.state
    const { openOrders } = this.props
    if (cancelText === 'cancel all') {
      this._cancel(bncClient, openOrders)
    } else if (cancelText === 'cancel buy') {
      const openBuyOrders = openOrders.filter(item => item.side === 1)
      this._cancel(bncClient, openBuyOrders)
    } else if (cancelText === 'cancel sell') {
      const openSellOrders = openOrders.filter(item => item.side === 2)
      this._cancel(bncClient, openSellOrders)
    } else {
      this._cancel(bncClient, [toCancelItem])
    }
  }

  _hide = () => {
    this.setState({ toCancelItem: {}, isConfirm: false })
  }

  _paging = current => {
    this._getOpenOrders({ offset: (current - 1) * PAGE_SIZE })
  }

  _buildColumns = wcClient => {
    const { formatI18nText } = this.props
    const columns = [
      {
        title: formatI18nText('exchange.txHash'),
        headerAlign: 'left',
        sorter: true,
        dataIndex: 'txHash',
        key: 'TxHash',
        width: '15%',
        render: item => <TxHash hash={item.txHash} />,
      },
      {
        title: formatI18nText('exchange.date'),
        dataIndex: 'date',
        headerAlign: 'left',
        sorter: true,
        key: 'Date',
        width: '15%',
        render: item => (
          <DateItem>
            <FontNumber value={moment(item.date).format('MM-DD H:mm:ss')} />
          </DateItem>
        ),
      },
      {
        title: formatI18nText('exchange.pair'),
        dataIndex: 'pair',
        key: 'Pair',
        width: '10%',
        render: item => <CellItem>{item.pair && item.pair.replace(/-[A-F0-9]+/g, '')}</CellItem>,
      },
      {
        title: formatI18nText('exchange.side'),
        dataIndex: 'side',
        key: 'Side',
        width: '10%',
        render: item => <Side text={item.side} />,
      },
      {
        title: formatI18nText('exchange.price'),
        dataIndex: 'price',
        key: 'Price',
        width: '15%',
        render: item => (
          <CellItem>
            <FontNumber value={toNonExponential(item.price)} />
          </CellItem>
        ),
      },
      {
        title: formatI18nText('exchange.amount'),
        dataIndex: 'amount',
        key: 'Amount',
        width: '10%',
        render: item => (
          <CellItem>
            <FontNumber value={item.amount} />
          </CellItem>
        ),
      },
      {
        title: formatI18nText('exchange.filled'),
        dataIndex: 'filled',
        key: 'Filled',
        width: '10%',
        render: item => <Filled value={item.filled} />,
      },
      {
        title: formatI18nText('exchange.notional'),
        dataIndex: 'total',
        key: 'Notional',
        width: '10%',
        render: item => (
          <CellItem>
            <FontNumber value={parseFloat(item.total).toFixed(6)} />
          </CellItem>
        ),
      },
      {
        title: '',
        dataIndex: 'op',
        key: 'Total',
        width: '5%',
        render: item => (
          <div style={{ paddingRight: '10px' }}>
            <OpItem
              onClick={ev => {
                this._cancelOne(item, ev, wcClient)
              }}
            >
              <Icon type="close" size="14" />
            </OpItem>
          </div>
        ),
      },
    ]
    return columns
  }

  _buildDataSource = () => {
    const { openOrders } = this.props
    const result = []
    openOrders &&
      openOrders.forEach(order => {
        result.push({
          txHash: order.transactionHash,
          date: order.orderCreateTime,
          pair: order.symbol,
          side: order.side === 1 ? 'Buy' : 'Sell',
          price: roundValue(order.price),
          amount: roundValue(order.quantity),
          cumulateQuantity: order.cumulateQuantity,
          filled: (order.cumulateQuantity / order.quantity) * 100,
          total: roundValue(order.price * order.quantity),
          op: '',
          orderId: order.orderId,
        })
      })
    return result
  }

  render() {
    const { total, formatI18nText } = this.props
    const { cancelText, isConfirm, showNotify, notifyType, notifyMsg, notifyTitle } = this.state

    const dataSource = this._buildDataSource()

    return (
      <DexThemeProvider theme="light">
        <WalletConnectClientConsumer>
          {wcClient => (
            <BNCClientConsumer>
              {bncClient => (
                <Fragment>
                  <DesktopWrap>
                    <Layout>
                      <Wrapper>
                        <Content>
                          <Title>{formatI18nText('openOrders.title')}</Title>
                          {hasPrivateKey() && (
                            <FilterWrap>
                              <FilterButtons>
                                <FilterButton onClick={this._cancelAll(wcClient)}>
                                  <span>{formatI18nText('openOrders.cancelAll')}</span>
                                </FilterButton>
                                <FilterButton onClick={this._cancelBuy(wcClient)}>
                                  <span>{formatI18nText('openOrders.cancelBuy')}</span>
                                </FilterButton>
                                <FilterButton onClick={this._cancelSell(wcClient)}>
                                  <span>{formatI18nText('openOrders.cancelSell')}</span>
                                </FilterButton>
                              </FilterButtons>
                            </FilterWrap>
                          )}

                          <OrderTable
                            columns={this._buildColumns(wcClient)}
                            dataSource={dataSource}
                          />
                          {dataSource.length > 0 && (
                            <PageWrap>
                              <Pagination totalCount={total} paging={this._paging} />
                            </PageWrap>
                          )}
                          {dataSource.length === 0 && (
                            <NoContent text={formatI18nText('openOrders.title')} />
                          )}
                        </Content>
                        {showNotify && (
                          <Notification
                            type={notifyType}
                            msg={notifyMsg}
                            title={notifyTitle}
                            close={() => {
                              this.setState({ showNotify: false })
                            }}
                          />
                        )}
                      </Wrapper>
                    </Layout>
                  </DesktopWrap>
                  <MobileWrap>
                    <Header />
                    <MobileContent>
                      <MobileTitle>
                        <h2>{formatI18nText('openOrders.title')}</h2>
                        <CancalAllMobile onClick={this._cancelAll(wcClient)}>
                          {formatI18nText('openOrders.cancelAll')}
                        </CancalAllMobile>
                      </MobileTitle>
                      {dataSource.map(order => (
                        <OrderItemMobile order={order} cancel={this._cancelOne} />
                      ))}
                      {dataSource.length === 0 && (
                        <MobileNoData>
                          <img src={Nodata} alt="" />
                        </MobileNoData>
                      )}
                    </MobileContent>
                    {isMobile() && <GlobalStyle />}
                  </MobileWrap>
                  {isConfirm && (
                    <Confirm
                      cancelText={
                        cancelText === 'cancel'
                          ? formatI18nText('openOrders.keepOrder')
                          : formatI18nText('openOrders.keepOrders')
                      }
                      okText={
                        cancelText === 'cancel'
                          ? formatI18nText('openOrders.cancelOrder')
                          : formatI18nText('openOrders.cancelOrders')
                      }
                      confirm={this._confirmCancel(bncClient)}
                      cancel={this._hide}
                    >
                      <ConfirmContent>
                        <img src={CancelWhite} alt={true} />
                        <p>
                          {`${formatI18nText('openOrders.areYourTrue')} ${formatI18nText(
                            `openOrders.${cancelText}`
                          )}`}
                          {'?'}
                        </p>
                      </ConfirmContent>
                    </Confirm>
                  )}
                  {/* Modal providers */}
                  <LedgerModalHost />
                  <TrezorModalHost />
                  <CoinomiModalHost />
                  <InfinitoModalHost />
                  <WalletConnectModal />
                </Fragment>
              )}
            </BNCClientConsumer>
          )}
        </WalletConnectClientConsumer>
      </DexThemeProvider>
    )
  }
}

const mapStateToProps = ({
  order: { openOrders },
  account: { privateKey, address, userInfo },
}) => ({
  openOrders: cloneDeep(openOrders.order),
  total: openOrders.total,
  privateKey,
  address,
  userInfo,
})

export default withI18n(connect(mapStateToProps)(OpenOrders))
